import React from "react";
import Masterbar from "./Masterbar";
import { DIAGNOSTICS_DATA_BAR } from "constants/ui-constants";

export default () => <Masterbar {...DIAGNOSTICS_DATA_BAR} />;
